<script>
import materialCategoryApi from '@/api/materialCategory';
import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import MaterialCategoryItemRecursive from '@/components/exchange/material/admin/MaterialCategoryItemRecursive.vue';
import MaterialCategoryForm from '@/components/exchange/material/admin/MaterialCategoryForm.vue';

export default {
  name: 'AdminMaterialCategories',
  components: {
    MaterialCategoryForm,
    MaterialCategoryItemRecursive,
    CommonSection,
    Default,
  },
  data() {
    return {
      items: [],
      editable: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      materialCategoryApi.fetchList({}, true).then(r => { this.items = r.items; });
    },
    async add(parent) {
      const res = await this.$refs.form.open({});
      if (!res) return;
      res.parent = parent?.['@id'] ?? null;
      await materialCategoryApi.create(res, true);
      this.load();
    },
    async edit(data) {
      const res = await this.$refs.form.open(data);
      if (!res) return;

      await materialCategoryApi.update(data.id, res, true);
      this.load();
    },
    async del(data) {
      if (!await this.$confirm(`Удалить ${data.name}?`)) return;

      await materialCategoryApi.delete(data.id, true);
      this.load();
    },
  },
};
</script>

<template lang="pug">
Default
  CommonSection(title="Редактирование категорий материалов")
    MaterialCategoryItemRecursive(:items="items" @add="add" @edit="edit" @del="del")
    MaterialCategoryForm(ref="form")
</template>

<style scoped lang="scss">

</style>
